<template>
  <b-modal
    id="datasetSelection"
    content-class="generic-release-modal"
    dialog-class="dataset-panel-dialog"
    :size="drtComponents ? 'lg' : 'md'"
    hide-footer
    centered
    @hide="handleClose"
    @show="selected=false"
  >
    <template #modal-header="{ close }">
      <div class="grm-header d-flex align-items-center w-100">
        <div class="grm-header-icon">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="#4db8ff" stroke-width="1.5"/>
            <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10A15.3 15.3 0 0 1 12 2z" stroke="#4db8ff" stroke-width="1.5"/>
            <path d="M4.93 4.93a16 16 0 0 1 14.14 0M4.93 19.07a16 16 0 0 0 14.14 0" stroke="#4db8ff" stroke-width="1.5"/>
          </svg>
        </div>
        <div class="grm-header-text">
          <h5 class="grm-title mb-0">Select a Release</h5>
          <p class="grm-subtitle mb-0">Choose a dataset to explore on the map</p>
        </div>
        <div class="grm-header-badge ml-auto">
          {{ releaseCount }} release{{ releaseCount !== 1 ? 's' : '' }} available
        </div>
        <fa :icon="['fas', 'times']" @click="close()" class="dataset-close-btn"/>
      </div>
    </template>

    <MMP_ANSI_DatasetPanel
      v-if="ansiComponent"
      :apiUrl="apiUrl"
      :currentExtent="selectedExtent"
      :customerName="customerName"
      :releases="ansiReleases"
      :selectedDataset="selectedDataset"
      :user="user"
      :ansiLayersButtonCtrl="ansiLayersButtonCtrl"
      @extentChanged="$emit('extentChanged', $event)"
      @returnHome="$emit('returnHome')"
      @setSelectedDataset="$emit('setSelectedDataset', $event)"
      @updateANSILayersPartNumber="$emit('updateANSILayersPartNumber', $event)"
      @updateSelset="$emit('updateSelset', $event)"
      @unloadLayers="$emit('unloadLayers', $event)"
      @selection="selected = true"
    />
    <MMP_DRT_DatasetPanel
      v-if="drtComponents"
      :currentExtent="selectedExtent"
      :releases="releases"
      :selectedDataset="selectedDataset"
      :user="user"
      @extentChanged="$emit('extentChanged', $event)"
      @returnHome="$emit('returnHome')"
      @setSelectedDataset="$emit('setSelectedDataset', $event)"
      @setShowDRTLayers="$emit('setShowDRTLayers')"
      @updateDRTLayersPartNumber="$emit('updateDRTLayersPartNumber', $event)"
      @selection="selected = true"
    />
  </b-modal>
</template>

<style scoped>
.dataset-close-btn {
  color: whitesmoke;
  font-size: 1rem;
  cursor: pointer;
  transition: color 0.15s ease;
}

.dataset-close-btn:hover {
  opacity: 0.75;
}
</style>

<script>
import MMP_ANSI_DatasetPanel from '../MMP_ANSI/MMP_ANSI_DatasetPanel.vue'
import MMP_DRT_DatasetPanel from '../MMP_DRT/MMP_DRT_DatasetPanel.vue'
export default {
  name: 'MMP_DatasetSelection',
  components: {
    MMP_ANSI_DatasetPanel,
    MMP_DRT_DatasetPanel
  },
  props: [
    'ansiComponent',
    'ansiLayersButtonCtrl',
    'ansiReleases',
    'ansiSelset',
    'apiUrl',
    'customerName',
    'drtComponents',
    'releases',
    'selectedDataset',
    'selectedExtent',
    'user'
  ],
  data() {
    return {
      selected: false
    }
  },
  computed: {
    releaseCount() {
      if (this.ansiComponent) return (this.ansiReleases || []).length
      if (this.drtComponents) return (this.releases || []).length
      return 0
    }
  },
  methods: {
    handleClose() {
      if (!this.selected) {
        this.$emit('returnHome')
      }
    }
  }
}
</script>
